import { Modal, Row, Col, Divider, Card, QRCode } from "antd";
import moneyFormat from "functions/utils/moneyFormat";

export const VatPreview = ({ open, close }) => {
  const qrData = open;

  if (!qrData) return null;

  return (
    <Modal
      open={open}
      title={
        <span className="text-[#28a745] font-bold text-lg">НӨАТ баримт</span>
      }
      onCancel={close}
      footer={null}
      width={420}
      style={{ top: 20 }}
    >
      <div id="vatSide" className="p-4 text-sm">
        <Card
          bordered={false}
          className="rounded-xl shadow-md border border-[#28a745]/30"
        >
          <div className="mb-4 space-y-1 text-gray-700">
            <div>
              <strong className="text-gray-600">ДДТД:</strong>{" "}
              <span className="text-xs">{qrData.id}</span>
            </div>
            <div>
              <strong className="text-gray-600">ТТД:</strong>{" "}
              {qrData.merchantTin}
            </div>
            <div>
              <strong className="text-gray-600">Огноо:</strong> {qrData.date}
            </div>
          </div>

          <Divider className="border-[#28a745]/30" />

          <Row className="text-center font-semibold text-gray-600 mb-2">
            <Col span={6}>ТШ</Col>
            <Col span={6}>НӨАТ</Col>
            <Col span={6}>НЭГЖ</Col>
            <Col span={6}>НИЙТ</Col>
          </Row>
          <Row className="text-center text-gray-800 mb-4">
            <Col span={6}>{qrData.receipts?.[0]?.items?.[0]?.qty}</Col>
            <Col span={6}>{moneyFormat(qrData.totalVAT)}</Col>
            <Col span={6}>{moneyFormat(qrData.totalAmount)}</Col>
            <Col span={6}>{moneyFormat(qrData.totalAmount)}</Col>
          </Row>

          <Divider className="border-[#28a745]/30" />

          <div className="text-gray-700 mb-3 space-y-1">
            <div className="flex justify-between">
              <span>НХАТ:</span>
              <span>0.00</span>
            </div>
            <div className="flex justify-between">
              <span>НӨАТ:</span>
              <span>{moneyFormat(qrData.totalVAT)}</span>
            </div>
            <div className="flex justify-between font-semibold">
              <span>Нийт дүн:</span>
              <span className="text-[#28a745]">
                {moneyFormat(qrData.totalAmount)}
              </span>
            </div>
            <div className="flex justify-between">
              <span>Бэлэн:</span>
              <span>{moneyFormat(qrData.totalAmount)}</span>
            </div>
          </div>

          {qrData.lottery && (
            <div className="text-center mt-4 mb-2">
              <div className="text-gray-600">Сугалааны дугаар</div>
              <div className="text-[#28a745] font-bold text-lg">
                {qrData.lottery}
              </div>
            </div>
          )}

          <div className="flex justify-center mt-4">
            <QRCode value={qrData.qrData} size={180} />
          </div>
        </Card>
      </div>
    </Modal>
  );
};
